module.exports = "/assets/45d8b73f811638d9042558ab7dd9a573.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/QZ.png
// module id = 1769
// module chunks = 0